import { Box, Typography, Button, Divider } from "@mui/material";
import StarIcon from '@mui/icons-material/Star';
import { urlImg } from "../../common/helpers";

const ProfileCard = ({ user, profile }) => {
  // Calificación del proveedor = promedio ponderado de sus servicios (por nº de reseñas)
  const serviciosCalificados = (profile?.servicios || []).filter(s => s.ratingPromedio > 0 && s.ratingTotal > 0);
  const totalResenas = serviciosCalificados.reduce((acc, s) => acc + s.ratingTotal, 0);
  const ratingProveedor = totalResenas > 0
    ? serviciosCalificados.reduce((acc, s) => acc + s.ratingPromedio * s.ratingTotal, 0) / totalResenas
    : 0;

  let avatarUrl = "";
  if (user?.avatar) {
    const avatarStr = user.avatar.toString();
    if (avatarStr.startsWith("http")) {
      avatarUrl = avatarStr;
    } else if (avatarStr.startsWith("//")) {
      // Reemplazamos los // iniciales por https:// para que la imagen cargue correctamente
      avatarUrl = avatarStr.replace(/^\/\//, "https://");
    } else {
      avatarUrl = `${urlImg}/users/${user._id}/${user._id}.jpg?v=${user.version}`;
    }
  }

  return (
    <Box className="profile-card-container">
      <Box className="profile-image-section">
        <img
          src={avatarUrl || "/default-avatar.png"}
          alt={user?.name}
          className="profile-big-avatar"
        />
        <Box className="profile-name-overlay">
          <Typography variant="h5" sx={{ fontWeight: 700, textAlign: 'center' }}>
            {user?.name} {user?.apellido}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 0.5 }}>
            <Typography variant="body2" sx={{ color: '#737791', mr: 1 }}>
              {profile?.perfil?.rol || "Experto"}
            </Typography>
            {ratingProveedor > 0 ? (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <StarIcon sx={{ color: '#0E2465', fontSize: 18, mr: 0.2 }} />
                <Typography variant="body2" sx={{ fontWeight: 700 }}>{ratingProveedor.toFixed(1)}</Typography>
              </Box>
            ) : (
              <Typography variant="body2" sx={{ fontWeight: 700, color: '#94A3B8' }}>Nuevo</Typography>
            )}
          </Box>
        </Box>
      </Box>

      <Box sx={{ p: 3 }}>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="body2" sx={{ color: '#393939', lineHeight: 1.6, mb: 3 }}>
          {profile?.perfil?.desc || "Hola, no se ha proporcionado una descripción todavía."}
        </Typography>

        <Button
          variant="contained"
          fullWidth
          className="btn-contactar"
          sx={{
            bgcolor: '#0E2465',
            borderRadius: '4px',
            textTransform: 'none',
            py: 1
          }}
        >
          Contactar
        </Button>
      </Box>
    </Box>
  );
};

export default ProfileCard;
